import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExclamationCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconExclamationCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 14.5C11.3373 14.5 10.7998 15.0375 10.7998 15.7002C10.7999 16.3628 11.3373 16.9004 12 16.9004C12.6627 16.9004 13.2001 16.3628 13.2002 15.7002C13.2002 15.0375 12.6627 14.5 12 14.5ZM11 13H13V7.5H11V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExclamationCircle;
